import React, { useState, useEffect, useRef } from 'react';
import ChartCheckbox from '../Backoffice/Dashboard/Tools/ChartCheckbox';

const CheckboxGroup = ({ items = [], disabled = false, onChange, onChangeItem, resetTrigger, autoSelect = [] }) => {
    const [checkedPermissions, setCheckedPermissions] = useState({});
    const previousAutoSelect = useRef(autoSelect);

    const handleCheckboxChange = (groupName, permission, isChecked) => {
        setCheckedPermissions((prev) => {
            const updatedGroup = prev[groupName] || [];
            const updatedPermissions = isChecked
                ? [...updatedGroup, permission.value]
                : updatedGroup.filter((value) => value !== permission.value);

            const updatedState = { ...prev, [groupName]: updatedPermissions };

            if (onChange) {
                const allSelectedPermissions = Object.values(updatedState).flat();
                onChange(allSelectedPermissions);
            }

            return updatedState;
        });
    };

    useEffect(() => {
        // Reset checkedPermissions when resetTrigger changes
        setCheckedPermissions({});
        if (onChange) {
            onChange([]);
        }
    }, [resetTrigger]);

    // Automatically select items when autoSelect prop changes
    // useEffect(() => {
    //     if (JSON.stringify(autoSelect) !== JSON.stringify(previousAutoSelect.current)) {
    //         const validSelections = {};

    //         // Populate valid selections by checking if autoSelect includes the permission value
    //         items.forEach(group => {
    //             const validGroupSelections = group.permissions
    //                 .filter(permission => autoSelect.includes(permission.value))
    //                 .map(permission => permission.value);

    //             if (validGroupSelections.length > 0) {
    //                 validSelections[group.name] = validGroupSelections;
    //             }
    //         });

    //         setCheckedPermissions(validSelections);
    //         if (onChange) {
    //             const allSelectedPermissions = Object.values(validSelections).flat();
    //             onChange(allSelectedPermissions);
    //         }

    //         // Store the current autoSelect as previousAutoSelect
    //         previousAutoSelect.current = autoSelect;
    //     }
    // }, [autoSelect, items, onChange]);

    return (
        <div className="checkbox-group-container">
            {items.map((group, groupIndex) => (
                <div
                    key={groupIndex}
                    className="checkbox-group"
                    style={{ gridColumn: group.columnSpan }}
                >
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{group.name}</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        {group.permissions.map((permission, permissionIndex) => (
                            <>
                                {
                                    onChangeItem != undefined ? (
                                        <ChartCheckbox
                                            disabled={disabled}
                                            size='14px'
                                            key={permissionIndex}
                                            label={permission.label}
                                            initialChecked={autoSelect.indexOf(permission.value) >= 0}
                                            // onChange={(isChecked) => handleCheckboxChange(group.name, permission, isChecked)}
                                            onChange={(isChecked) => onChangeItem(permission, isChecked)}
                                        />
                                    ) : (
                                        <ChartCheckbox
                                            disabled={disabled}
                                            size='14px'
                                            key={permissionIndex}
                                            label={permission.label}
                                            initialChecked={autoSelect.indexOf(permission.value) >= 0}
                                            onChange={(isChecked) => handleCheckboxChange(group.name, permission, isChecked)}
                                        // onChange={(isChecked) => onChangeItem(permission, isChecked)}
                                        />
                                    )
                                }
                            </>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CheckboxGroup;
